import MarkdownPage from "../components/MarkdownPage";

export default function ReturnsPolicyPage() {
    return (
        <MarkdownPage
            title="Returns & Refund Policy – CV Box"
            description="CV Box credit refund policy – one-time purchases, credits never expire."
            markdownFile="/content/returns.md"
        />
    );
}